export const INVOICES_BASE_ROUTE = '/account/invoices';

export const INVOICES_ROUTES = {
  invoicesList: INVOICES_BASE_ROUTE,
  invoiceInfo: `${INVOICES_BASE_ROUTE}/info`,
};
